/**
 * Bootstrap de cliente de Next (15.3+/16): Next carga este archivo antes de la
 * hidratación, sin necesidad de 'use client' ni de meter un provider más en el
 * árbol —que en esta app ya es profundo y cuyo layout raíz es async
 * (`await headers()` + `force-dynamic`)—.
 *
 * Arrancar PostHog acá es lo que permite ver errores que ocurren ANTES de que
 * monte cualquier componente.
 */
import { initObservability } from '@/lib/observability';

initObservability();
